exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-player-question[data-v-74a09a52] {\n  padding: 0 8.5%;\n  overflow: hidden;\n}\n.video-player-classroom[data-v-74a09a52] {\n  padding: 0 0%;\n  margin: 0 auto;\n  max-width: 100vh;\n}\n@media screen and (max-width: 764px) {\n.video-player-classroom[data-v-74a09a52] {\n    max-width: 100%;\n}\n}", ""]);

// exports
